import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { address } from './address';
import { SetField } from '../components/Table/fields/SetField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPBooleanField } from '../components/Table/fields/SPBooleanField';
import { AccommodationContact } from '../components/Contacts/AccommodationContact';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { AccommodationAttachment } from '../components/Images/AccommodationAttachment';
import { AccommodationImages } from '../components/Images/AccommodationImages';
import { AccommodationVenues } from '../components/Venues/AccommodationVenues';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { AccommodationCorporateComponent } from '../components/LegalAndFinance/AccommodationCorporate';
import { SPSetAddressField } from '../components/Table/fields/SPSetAddressField';
import {SPSelectWithOutAutocomplete} from "../components/Table/fields/SPSelectWithOutAutocompleteField";
import {SPSetField} from "../components/Table/fields/SPSetField";

export const activityGroup: SchemaWithClient<any> = {
  name: 'Activity Group',
  pluralName: 'Activity Group',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],

  sections: [
    {
      id: 1,
      width: 12,
      label: 'General Data',
      name: 'general',
      hasDefaultButtons: true,
      grids: [
        {
          width: 4,
          columns: [
            {
              columnName: 'name',
              name: 'Name',
              fieldRenderer: SPTextField,
            },
            {
              name: 'Company',
              fieldRenderer: SPTextField,
              columnName: 'legal_name',
            },
            {
              columnName: 'description',
              name: 'Description',
              fieldRenderer: SPRichTextField,
            },
          ],
        },
        {
          width: 4,
          columns: [
            {
              name: 'Category',
              fieldRenderer: SPSelectField.tableAdapter(
                enumItems.accommodationCategory
              ),
              columnName: 'activity_category',
            },
            /*{
              name: 'Type',
              fieldRenderer: SPSelectField.tableAdapter(enumItems.activityType),
              columnName: 'activity_type',
            },*/
            {
              name: 'Availability',
              fieldRenderer: SPRichTextField,
              columnName: 'availability',
            },
            {
              name: 'Notes',
              fieldRenderer: SPRichTextField,
              columnName: 'notes',
            },
          ],
        },
        {
          width: 4,
          columns: [
            /* {
              name: 'Default provider',
              fieldRenderer: SPBooleanField,
              columnName: 'default_provider',
            },*/
            {
              name: 'Active',
              fieldRenderer: SPBooleanField,
              columnName: 'active',
            },
            {
              name: 'Websites',
              fieldRenderer: SPRichTextField,
              columnName: 'website',
            },
            {
              name: 'Hotline',
              fieldRenderer: SPTextField,
              columnName: 'hotline',
            },
          ],
        },
      ],
    },
  ],

  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    subtitle: {
      name: 'Subtitle',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    description: {
      name: 'Description',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    activities: {
      name: 'Activities',
      fieldRenderer: SetField.tableAdapter(enumItems.activity),
      slidePaneFieldRenderer: SPSetField.tableAdapter(enumItems.activity),
      multiSwitchboard: true,
      url: enumItems.activity.client.getAllPath,
      tempSchema: enumItems.activity,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
      defaultShow: false,
    },
  },
  viewTable: 'activity-groups',
  client: new Client('/activity-groups'),
};
